import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ breakpoints, custom }: Theme) => ({
  modal: {
    maxWidth: 500,
    paddingTop: 50,

    [breakpoints.up('sm')]: {
      paddingLeft: 40,
      paddingRight: 40,
    },
  },
  alert: {
    marginBottom: 30,
    '& span a': {
      color: custom.grey[3],
      textDecoration: 'underline',
    },
  },
  button: {
    fontSize: 16,
    padding: '14px 19px',
  },
}));
